module.exports = __webpack_public_path__ + "static/img/preview-07.81c0b3fb.webp";